import { createSelector } from '@reduxjs/toolkit';

import { ValidationStatuses } from '@cashier/cashier-model';

import {
  PAYMENT_FORM_FEATURE_KEY,
  PaymentFormState,
} from './paymentForm.slice';

export const getPaymentFormState = (rootState: any): PaymentFormState =>
  rootState[PAYMENT_FORM_FEATURE_KEY];

export const selectFormVersion = createSelector(
  getPaymentFormState,
  (s) => s.version,
);
export const selectPaymentFormPayload = createSelector(
  getPaymentFormState,
  (s) => s.formPayload,
);

export const selectPaymentFormPayloadItem = (fieldName: string) =>
  createSelector(
    getPaymentFormState,
    (s) =>
      s.formPayload?.[fieldName] || {
        value: null,
        interactionCompleted: true,
        validationStatus: ValidationStatuses.UNDEFINED,
        errors: [],
      },
  );
export const selectPaymentFormSchema = createSelector(
  getPaymentFormState,
  (s) => s.formSchema,
);

export const selectPaymentFormStatus = createSelector(
  getPaymentFormState,
  (s) => s.status,
);

export const selectDropdownOptions = createSelector(
  getPaymentFormState,
  (s) => s.options,
);
